import { Icon as E } from "./index250.mjs";
import e, { useRef as v, useState as i, useEffect as a } from "react";
import t from "./index251.mjs";
import w from "./index252.mjs";
import p from "./index253.mjs";
const m = ({ iconType: n, label: o, isListItem: r = !1 }) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: t.tag,
    "data-testid": "room-details-tag",
    role: r ? "listitem" : void 0,
    "aria-label": r ? o : void 0
  },
  n ? /* @__PURE__ */ e.createElement(E, { type: n }) : null,
  /* @__PURE__ */ e.createElement("span", { className: n ? "" : t.no_icon }, o)
), I = ({
  tags: n,
  scrollable: o = !1
}) => {
  const r = v(null), [u, f] = i(!1), [_, d] = i(!1), l = () => {
    if (r.current) {
      const { scrollLeft: c, scrollWidth: s, clientWidth: h } = r.current;
      f(c > 0), d(c + h < s - 10);
    }
  };
  a(() => {
    if (o)
      return l(), window.addEventListener("resize", l), () => {
        window.removeEventListener("resize", l);
      };
  }, [o]);
  const b = () => {
    r.current && (r.current.scrollBy({ left: -150, behavior: "smooth" }), setTimeout(l, 300));
  }, g = () => {
    r.current && (r.current.scrollBy({ left: 150, behavior: "smooth" }), setTimeout(l, 300));
  };
  return a(() => {
    o && l();
  }, [n, o]), o ? /* @__PURE__ */ e.createElement("div", { className: t.scrollable_container }, u ? /* @__PURE__ */ e.createElement("div", { className: t.scroll_left_button_container }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: t.scroll_button + " " + t.left_button,
      onClick: b,
      "aria-label": I18n.t("booking_engine.accessibility.scroll_left")
    },
    /* @__PURE__ */ e.createElement(p, null)
  )) : null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: t.scroll_content,
      ref: r,
      onScroll: l,
      role: "list",
      "aria-label": I18n.t("booking_engine.accessibility.scrollable_tags"),
      tabIndex: 0
    },
    n.map(({ iconType: c, label: s }) => /* @__PURE__ */ e.createElement(m, { key: s, iconType: c, label: s, isListItem: !0 }))
  ), _ ? /* @__PURE__ */ e.createElement("div", { className: t.scroll_right_button_container }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: t.scroll_button + " " + t.right_button,
      onClick: g,
      "aria-label": I18n.t("booking_engine.accessibility.scroll_right")
    },
    /* @__PURE__ */ e.createElement(w, null)
  )) : null) : /* @__PURE__ */ e.createElement("div", { className: t.container }, n.map(({ iconType: c, label: s }) => /* @__PURE__ */ e.createElement(m, { key: s, iconType: c, label: s })));
};
export {
  I as RoomDetailsTags
};
